import warnLastDayComponent from './warnLastDay.component';

let warnLastDayModule = angular.module('vacations-absences.warnLastDay', [])

.component('warnLastDay', warnLastDayComponent)

.name;

export default warnLastDayModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/warnLastDay/warnLastDay.js